module.exports = __webpack_public_path__ + "img/1557912887.818cf198.jpg";